import { __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// @ts-ignore-next-line importsNotUsedAsValues
import { forwardRef, useRef } from 'react';
import classNames from 'classnames';
import noop from 'lodash/fp/noop';
import useHover from '../../hooks/useHover';
import mergeRefs from '../../utils/mergeRefs';
const TypeCounter = forwardRef((props, ref) => {
    const { icon, value, isActive, hasFilter = false, enableActivity = false, onClick = noop, type, hideOnZero = false } = props, remainingProps = __rest(props, ["icon", "value", "isActive", "hasFilter", "enableActivity", "onClick", "type", "hideOnZero"]);
    const internalRef = useRef(null);
    const mergedRef = mergeRefs([ref, internalRef]);
    const isHover = useHover(internalRef);
    const wrapperClassName = classNames('TypeCounter', 'display-flex align-items-center', 'user-select-none', 'margin-right-2', enableActivity ? 'cursor-pointer' : 'pointer-events-none', enableActivity && hasFilter && !isActive && !isHover && 'opacity-50');
    const counterClassNames = classNames('TreeLabelCount', 'label label-condensed', isHover && !isActive && 'bg-white text-color-darker', isHover && !isActive && 'border-color-gray', isHover && isActive && 'border-color-primary', isActive ? 'label-primary' : 'label-muted label-filled');
    const handleClick = () => type && onClick(type);
    if (hideOnZero && !value) {
        return null;
    }
    return (_jsxs("div", Object.assign({ ref: mergedRef }, remainingProps, { className: wrapperClassName, onClick: handleClick }, { children: [_jsx("span", { className: `rioglyph rioglyph-${icon} text-size-16 margin-right-2` }), _jsx("span", Object.assign({ className: counterClassNames }, { children: value || 0 }))] })));
});
export default TypeCounter;
